export default {
  pullRefresh: {
    TITLE: '同步全球品质生活，海外直邮到家',
    PULL_REFRESH: '下拉刷新',
    RELEASE_REFRESH: '释放刷新',
    LOADING: '加载中...'
  },
  LOGIN_TOOLTIP: {
    TEXT: '同步全球品质生活，海外直邮到家',
    BUTTON_TEXT: '立即登录',
    OPEN_APP: '打开APP'
  }
};
